import React from "react";
import { render } from "react-dom";
import { ResponsiveBar } from "@nivo/bar";

// make sure parent container have a defined height when using responsive component,
// otherwise height will be 0 and no chart will be rendered.
// website examples showcase many properties, you'll often use just a few of them.

const colorRange = [
  "rgba(252,87,122,0.8)",
  "#FFC233",
  "#FF9F40",
  "rgba(0,170,255,0.8)",
  "rgba(66,80,251,0.8)"
];

const HorizontalBarChart = ({ data, isSmall }) => {
  return (
    <ResponsiveBar
      data={data}
      keys={[
        "proactivity",
        "leadership",
        "resilience",
        "publicSpeaking",
        "teamCohesion"
      ]}
      indexBy="category"
      margin={{
        top: 10,
        right: 60,
        bottom: 60,
        left: 120
      }}
      padding={0.4}
      layout="horizontal"
      colorBy={object => {
        return object.data.color;
      }}
      borderRadius={12}
      borderColor="inherit:darker(1.6)"
      enableGridY={false}
      axisTop={null}
      axisRight={null}
      axisBottom={{
        tickSize: 5,
        tickPadding: 5,
        tickRotation: 0,
        legend: "Nombre d'actions",
        legendPosition: "middle",
        legendOffset: 45
      }}
      axisLeft={{
        tickSize: 5,
        tickPadding: 5,
        tickRotation: 0,
        legendPosition: "middle",
        legendOffset: -40
      }}
      labelSkipWidth={12}
      labelSkipHeight={12}
      //   labelTextColor="#fff"
      labelTextColor="inherit:darker(1.6)"
      animate={true}
      motionStiffness={90}
      motionDamping={15}
      legends={[]}
      //   legends={[
      //     {
      //       //   dataFrom: "keys",
      //       dataFrom: "keys",
      //       anchor: "bottom-right",
      //       direction: "column",
      //       justify: false,
      //       translateX: 120,
      //       translateY: 0,
      //       itemsSpacing: 2,
      //       itemWidth: 100,
      //       itemHeight: 20,
      //       itemDirection: "left-to-right",
      //       itemOpacity: 0.85,
      //       symbolSize: 20,
      //       effects: [
      //         {
      //           on: "hover",
      //           style: {
      //             itemOpacity: 1
      //           }
      //         }
      //       ]
      //     }
      //   ]}
    />
  );
};

export default HorizontalBarChart;
